import { Suspense } from 'react';

import { SettingButton } from './SettingButton';
import { YearButton } from './YearButton';
import { AccountButton } from './AccountButton';

export const StatusBar = () => {
  return (
    <div className="h-16 w-auto p-2 bg-darkblue_100 rounded-bl-lg flex shadow shadow-darkblue_40">
      <div className="flex flex-row justify-end gap-6 items-center self-center m-4">
        <YearButton />
        <SettingButton />
        <div className="flex flex-col justify-start">
          <Suspense
            fallback={<div className="animate-pulse text-white text-sm">ユーザー情報取得中</div>}
          >
            <AccountButton />
          </Suspense>
        </div>
      </div>
    </div>
  );
};
